var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_162","data-name":"Group 162","transform":"translate(-1700 -603)"},React.createElement("g",{"id":"Group_161","data-name":"Group 161","transform":"translate(-270.5 19.5)"},[React.createElement("line",{"id":"Line_5","data-name":"Line 5","x2":"20","y2":"20","transform":"translate(1990.5 603.5)","fill":"none","stroke":"#04103B","strokeWidth":"3","key":0}),React.createElement("line",{"id":"Line_6","data-name":"Line 6","x1":"20","y2":"20","transform":"translate(1990.5 603.5)","fill":"none","stroke":"#04103B","strokeWidth":"3","key":1})])));
}

CloseIconInline.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
